import { CurrencyAmount, JSBI, Token, Trade } from '@uniswap/sdk'
import React, { useCallback, useContext, useEffect, useMemo, useState } from 'react'
import { ArrowDown } from 'react-feather'
import ReactGA from 'react-ga'
import { Button, Text } from 'rebass'
import styled, { ThemeContext } from 'styled-components'
import AddressInputPanel from '../../components/AddressInputPanel'
import { ButtonError, ButtonLight, ButtonPrimary, ButtonConfirmed } from '../../components/Button'
import Card, { GreyCard } from '../../components/Card'
import Column, { AutoColumn } from '../../components/Column'
import ConfirmSwapModal from '../../components/swap/ConfirmSwapModal'
import CurrencyInputPanel from '../../components/CurrencyInputPanel'
import { SwapPoolTabs } from '../../components/NavigationTabs'
import { AutoRow, RowBetween } from '../../components/Row'
import AdvancedSwapDetailsDropdown from '../../components/swap/AdvancedSwapDetailsDropdown'
import confirmPriceImpactWithoutFee from '../../components/swap/confirmPriceImpactWithoutFee'
import { ArrowWrapper, BottomGrouping, SwapCallbackError, Wrapper } from '../../components/swap/styleds'
import TradePrice from '../../components/swap/TradePrice'
import TokenWarningModal from '../../components/TokenWarningModal'
import ProgressSteps from '../../components/ProgressSteps'

import { ChainN, HexChainId, INITIAL_ALLOWED_SLIPPAGE } from '../../constants'
import { useActiveWeb3React } from '../../hooks'
import { useCurrency } from '../../hooks/Tokens'
import { ApprovalState, useApproveCallbackFromTrade } from '../../hooks/useApproveCallback'
import useENSAddress from '../../hooks/useENSAddress'
import { useSwapCallback } from '../../hooks/useSwapCallback'
import useToggledVersion, { Version } from '../../hooks/useToggledVersion'
import useWrapCallback, { WrapType } from '../../hooks/useWrapCallback'
import { useToggleSettingsMenu, useWalletModalToggle } from '../../state/application/hooks'
import { Field } from '../../state/swap/actions'
import {
    useDefaultsFromURLSearch,
    useDerivedSwapInfo,
    useSwapActionHandlers,
    useSwapState
} from '../../state/swap/hooks'
import { useExpertModeManager, useUserSlippageTolerance } from '../../state/user/hooks'
import { LinkStyledButton, TYPE } from '../../theme'
import { maxAmountSpend } from '../../utils/maxAmountSpend'
import { computeTradePriceBreakdown, warningSeverity } from '../../utils/prices'
import AppBody from '../AppBody'
import { ClickableText } from '../Pool/styleds'
import Loader from '../../components/Loader'
import { Box, Grid, useMediaQuery, createMuiTheme } from '@material-ui/core'
import Settings from '../../components/Settings'
import ScrollAnimation from 'react-animate-on-scroll';
import TopProgressBar from '../../components/TopProgressbar'
import './home.css'
import { Link } from 'react-router-dom'

export default function Home() {
    const isMobile = useMediaQuery('(max-width:1150px)')

    return (
        <section className='' style={{ width: '100%' }}>
            <TopProgressBar />
            <div className="home-header">
                <div className="bar">
                    <div className="section">
                        <div className="">
                            {/* <img className='logo' src="/images/degenswap.png" alt="" /> */}
                            <h1 className=' text-4xl text-[#0345ca]'>
                                ApeDEX
                            </h1>
                        </div>
                        <div className="links">
                            <p className="link active link-buy">
                                <svg className="MuiSvgIcon-root MuiSvgIcon-fontSizeMedium mui-icon css-vubbuv" focusable="false" aria-hidden="true" viewBox="0 0 24 24" data-testid="ContentCopyIcon">
                                    <path d="M16 1H4c-1.1 0-2 .9-2 2v14h2V3h12zm3 4H8c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h11c1.1 0 2-.9 2-2V7c0-1.1-.9-2-2-2m0 16H8V7h11z"></path>
                                </svg>
                                Copy Address
                            </p>
                        </div>
                    </div>
                </div>
            </div>
            <div className="home-body">
                <div className="">
                    {/* <ScrollAnimation animateIn='fadeIn'>
                        <h1>
                            animateIn
                        </h1>
                    </ScrollAnimation> */}
                    <div className="first-section">
                        <div className="section1">
                            <p className="section-header">Welcome.</p>
                            <p className="section-info">Introducing ApeDEX on Ape Chain 🐵</p>
                            <div className="link-buttons">
                                <Link to='/swap' className="link active section-link-buy link-buy">
                                    DEX
                                    <svg className="MuiSvgIcon-root MuiSvgIcon-fontSizeMedium mui-icon css-vubbuv" focusable="false" aria-hidden="true" viewBox="0 0 24 24" data-testid="LaunchIcon">
                                        <path d="M19 19H5V5h7V3H5c-1.11 0-2 .9-2 2v14c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2v-7h-2zM14 3v2h3.59l-9.83 9.83 1.41 1.41L19 6.41V10h2V3z"></path>
                                    </svg>
                                </Link>
                            </div>
                        </div>
                        <div className="section2">
                            <div className="cloud-svgt">
                                {/* <img src="/images/gif.gif" alt="" className="cloudSvg" /> */}
                                <video autoPlay={true} muted={false} playsInline={true} loop={true} className="pointer-events-none h-screen w-full object-contain">
                                    <source src="/wen.webm" type="video/webm" />
                                    <source src="/wen.mp4" type="video/mp4" />
                                </video>
                            </div>
                        </div>
                    </div>
                    <div className="second-section">
                        <div className="section-1">
                            <p className="section-header">Become An APE</p>
                            <div className="icons">
                                <a href="https://t.me/swapdegen" target="_blank">
                                    <svg className="MuiSvgIcon-root MuiSvgIcon-fontSizeMedium telegram-icon mui-icon css-vubbuv" focusable="false" aria-hidden="true" viewBox="0 0 24 24" data-testid="TelegramIcon">
                                        <path d="M9.78 18.65l.28-4.23 7.68-6.92c.34-.31-.07-.46-.52-.19L7.74 13.3 3.64 12c-.88-.25-.89-.86.2-1.3l15.97-6.16c.73-.33 1.43.18 1.15 1.3l-2.72 12.81c-.19.91-.74 1.13-1.5.71L12.6 16.3l-1.99 1.93c-.23.23-.42.42-.83.42z"></path>
                                    </svg>
                                </a>
                                <a href="https://twitter.com/swapdegen" target="_blank">
                                    <svg className="MuiSvgIcon-root MuiSvgIcon-fontSizeMedium twitter-icon mui-icon css-vubbuv" focusable="false" aria-hidden="true" viewBox="0 0 24 24" data-testid="XIcon">
                                        <path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z"></path>
                                    </svg>
                                </a>
                                <a href="https://warpcast.com/~/channel/swapdegen" target="_blank" className="twitter-icon mui-icon">
                                    <img src="/images/twitter-.svg" className="twitter-icon mui-icon" alt="" />
                                </a>
                                <a href="https://docs.swapdegen.tips/" target="_blank">
                                    <svg className="MuiSvgIcon-root MuiSvgIcon-fontSizeMedium twitter-icon mui-icon css-vubbuv" focusable="false" aria-hidden="true" viewBox="0 0 24 24" data-testid="BookmarksOutlinedIcon">
                                        <path d="M15 7v12.97l-4.21-1.81-.79-.34-.79.34L5 19.97V7zm4-6H8.99C7.89 1 7 1.9 7 3h10c1.1 0 2 .9 2 2v13l2 1V3c0-1.1-.9-2-2-2m-4 4H5c-1.1 0-2 .9-2 2v16l7-3 7 3V7c0-1.1-.9-2-2-2"></path>
                                    </svg>
                                </a>
                            </div>
                        </div>
                    </div>

                </div>
            </div>
            <div className="home-footer">
            </div>
        </section>
    )
}
